import Phaser from 'phaser'
import CameraController from '../components/camera_controller'
import Player, { SANTA } from '../actors/player'
import Spawner from '../editor/spawner'
import DifficultyManager from '../components/difficultyManager'
import { LAYER_PLAYER, LAYER_PARTICLES } from '../layers'
import LevelDefs from '../components/levelDefs'
import LevelEditor from '../editor/levelEditor'
import TitleScene from './title'
import { AnalyticsWrapper, ANALYTICS_COMPLETE, ANALYTICS_FAIL, ANALYTICS_START } from '/components/analyticsWrapper'
import { PokiWrapper } from '/components/pokiWrapper'

export default class GameScene extends Phaser.Scene {
  create () {
    if (process.env.NODE_ENV !== 'production') {
      window.scene = this
    }

    this.loadRegistry()
    this.setupCollisions()
    this.addActors()
    this.setupColorScheme()
    this.addBackground()

    this.setupParticles()
    this.doInit()
    this.setupResizing()

    // QQQ
    if (!this.hideTitle) {
      this.spawner.setLevelEmpty()
    }
    this.levelEditor.disable()

    // slow framerate Testing
    this.keyTest = this.input.keyboard.addKey('q')
    this.keyTestWasDown = false
    this.sleeptime = 0
  }

  setRating (rating) {
    this.difficultyManager.setRating(rating)
  }

  doInit () {
    this.finished = false
    this.isCustomLevel = false
    this.isLevelURL = false

    if (!this.hideTitle) {
      this.scene.run('TitleScene', { game: this, player: this.player })
    } else if (this.nRespawns > 0) {
      this.startLevel(this.game.registry.get('lastLevel'), this.nRespawns)
      if (this.nRespawns >= 3 && PokiWrapper.isActive()) {
        this.scene.run('SkipLevelScene', { game: this })
      }
    } else {
      this.startLevel(this.levelId, this.nRespawns)
    }
  }

  setupResizing () {
    this.landscape = window.innerWidth > window.innerHeight
    this.scale.on('resize', () => {
      const oldLS = this.landscape
      this.landscape = window.innerWidth > window.innerHeight
      if (this.landscape !== oldLS) {
        this.onResize()
      }
    })
    this.onResize()
  }

  addActors () {
    this.difficultyManager = new DifficultyManager(this)
    this.levelDefs = new LevelDefs(this)
    this.levelId = this.loadLevelProgress()
    this.spawner = new Spawner(this)
    this.levelEditor = new LevelEditor(this)
    this.add.existing(this.levelEditor)
    this.levelEditor.setupInput()
    this.addPlayer(-500, this.hideTitle, this.game.registry.get('selectedAnimal') || 0)
    this.cameraController = new CameraController(this, this.player)
    this.scene.run('TouchScene', { game: this, player: this.player })
  }

  loadRegistry () {
    this.nRespawns = this.game.registry.get('respawn')
    this.hideTitle = this.game.registry.get('hideTitle')
    this.lastPlayerY = this.game.registry.get('lastPlayerY')
    this.game.registry.inc('nAttempts') // increases if in registry, otherwise sets it to 1
  }

  setupCollisions () {
    this.collisionGroup1 = this.matter.world.nextGroup()// 1 // player, obstacles
    this.collisionGroup2 = this.matter.world.nextGroup()// 2 // level editor, handlers
    this.collisionGroup3 = this.matter.world.nextGroup(true)// -3 // tails

    this.collisionCategory1 = this.matter.world.nextCategory()// 4 // player
    this.collisionCategory2 = this.matter.world.nextCategory()// 8 // obstacles
    this.collisionCategory3 = this.matter.world.nextCategory()// 16 // editor, handlers
    this.collisionCategory4 = this.matter.world.nextCategory()// -32 // tails
  }

  addBackground () {
    if (!this.matter.world.drawDebug) {
    // NB: this breaks DEBUG DRAWING and LOCALHOST-GUIDE DRAWING
      this.bg = this.add.graphics()
      this.bg.clear()
      // this.bg.setTexture('white', 0)
      this.bg.fillGradientStyle(this.colorBG2, this.colorBG2, this.colorBG, this.colorBG, 1)
      // this.bg.fillGradientStyle(this.colorBG, this.colorBG, this.colorBG, this.colorBG, 1)
      // this.bg.fillStyle(this.colorBG, 1)
      this.bg.fillRect(-2000, -1000, 4000, 2000)
      this.bg.setScrollFactor(0)
    }

    this.addParrallaxLayers()
  }

  addParrallaxLayers () {
    var cont = this.add.container(0, 0)
    const s = 1.5
    const offY = -200
    const offX = -200 + (this.levelId % 5) * -50
    for (var i = 0; i < 10; i++) {
      for (var j = -8; j < 8; j++) {
        // if (this.game.registry.get('selectedAnimal') === SANTA) {
        // cont.add(this.add.image(i * 600 * s, j * 400 * s, 'santa_images', 'santa_bg2').setAlpha(0.1).setScale(s))
        // } else {
        cont.add(this.add.image(i * 600 * s, j * 400 * s, 'images', 'bg2').setTint(this.colorBG2).setScale(s)).setAlpha(0.125)
        // }
      }
    }
    cont.setAngle(this.levelId % 5)
    cont.setPosition(offX, offY)
    cont.setScrollFactor(0.5, 1)

    cont = this.add.container(0, 0)
    for (i = 0; i < 10; i++) {
      for (j = -8; j < 8; j++) {
        // if (this.game.registry.get('selectedAnimal') === SANTA) {
        // cont.add(this.add.image(i * 600 * s, j * 400 * s, 'santa_images', 'santa_bg2').setAlpha(0.1).setScale(s))
        // } else {
        cont.add(this.add.image(i * 600 * s, j * 400 * s, 'images', 'bg2').setTint(0xffffff).setScale(s)).setAlpha(0.125)
        // }
      }
    }
    cont.setAngle(this.levelId % 5)
    cont.setPosition(offX - 600, offY + 200)
    cont.setScrollFactor(0.75, 1)
  }

  setupColorScheme () {
    var colors = this.genColors()// New()// this.genColors(6)
    // console.log('colors.bg = \'' + colors.bg + '\'')
    // console.log('colors.bg2 = \'' + colors.bg2 + '\'')
    // console.log('colors.fg = \'' + colors.fg + '\'')
    // console.log('colors.sp = \'' + colors.sp + '\'')

    // SANTA
    if (this.game.registry.get('selectedAnimal') === SANTA) {
      colors.fg = 'eeeeff'
      colors.bg = '000011'
      colors.bg2 = '222299'
      colors.sp = 'eeeeff'// '01A43B'
    }

    // Generate a new color scheme every 5 levels:
    if ((this.levelId % 5 === 0 && this.nRespawns <= 0) || typeof this.game.registry.get('lastColorBG') === 'undefined') {
      this.game.registry.set('lastColorBG', colors.bg)
      this.game.registry.set('lastColorBG2', colors.bg2)
      this.game.registry.set('lastColorFG', colors.fg)
      this.game.registry.set('lastColorSp', colors.sp)
      this.game.registry.set('lastColorMv', colors.mv)
      this.game.registry.set('lastColorGu', colors.gu)
    }

    this.colorBG = '0x' + this.game.registry.get('lastColorBG')
    this.colorFG = '0x' + this.game.registry.get('lastColorFG')
    this.colorSpikes = '0x' + this.game.registry.get('lastColorSp')
    this.colorBG2 = '0x' + this.game.registry.get('lastColorBG2')
    this.colorMovers = '0x' + this.game.registry.get('lastColorMv')
    this.colorGuide = '0x' + this.game.registry.get('lastColorGu')
  }

  getBanner () {
    return this.scene.get('BannerAdScene')
  }

  addPlayer (y, hideTitle, index) {
    if (this.player) {
      this.player.destroy()
    }
    this.player = new Player(this, y, hideTitle, index)
    this.add.existing(this.player)
    this.player.setDepth(LAYER_PLAYER)
  }

  onResize () {
    if (this.landscape) {
      this.scale.setGameSize(1280, 720)
    } else {
      this.scale.setGameSize(720, 1280)
    }

    if (this.cameras.main) {
      if (this.bg) {
        this.bg.setPosition(this.scale.gameSize.width / 2, 360)
      }
    }

    // if (this.touch) {
    // this.touch.onResize(this.landscape)
    // }
  }

  sleep (seconds) {
    // watch out, we REALLY dont want this in game!!
    // var e = new Date().getTime() + (seconds * 1000)
    // while (new Date().getTime() <= e) {}
  }

  clearLevel () {
    this.spawner.clearLevel()
  }

  startRatedLevel (respawn = 0) {
    AnalyticsWrapper.addProgressionEvent(ANALYTICS_START, 'level_' + this.levelIdString())
    this.spawner.spawnRatedLevel(respawn)
  }

  startNewLevel () {
    console.log('startNewLevel()')
    this.isCustomLevel = true
    this.spawner.setLevelEmpty()
    this.doStart()
  }

  startLevel (id, nRespawns = 0) {
    if (nRespawns === 0) {
      this.startRatedLevel(nRespawns)
    } else {
      this.spawner.spawnLevelFromJSON(id, nRespawns)
    }

    this.doStart()
  }

  doStart () {
    if (!this.player.hasStarted) {
      PokiWrapper.commercialBreak(() => { this.start() })
    } else {
      this.start()
    }
  }

  start () {
    this.player.setupInput()
    this.levelEditor.setupInput()
    this.player.hasStarted = true
    this.startHUD()

    // if (this.game.registry.get('selectedAnimal') === SANTA) {
    //   this.snowEmitter.setEmitZone({
    //     type: 'random',
    //     source: new Phaser.Geom.Rectangle(-800, -20, this.spawner.finishX + 2000, 5)
    //   })
    // }
  }

  setupParticles () {
    this.particles = this.add.particles('images', 'circle')
    this.particles.setDepth(LAYER_PARTICLES)

    // snow particles
    if (this.game.registry.get('selectedAnimal') === SANTA) {
      this.snowParticles = this.add.particles('images', 'circle')
      this.snowParticles.setDepth(5)
      this.snowEmitter = this.snowParticles.createEmitter({
        tint: 0xEEEEFF,
        scale: 0.25,
        alpha: 0.75,
        lifespan: 6000,
        speedX: { min: -10, max: -60 },
        speedY: { min: 125, max: 200 },
        on: true,
        emitZone: {
          type: 'random',
          source: new Phaser.Geom.Rectangle(-800, -20, 3000, 5)
        }
      })
    }
  }

  startHUD () {
    this.scene.run('HudScene', { game: this, player: this.player })
    this.scene.run('NonEditorHudScene', { game: this })
  }

  startEditorHUD () {
    // this.scene.run('EditorHudScene', { game: this, player: this.player })
    this.scene.sleep('HudScene')
  }

  stopEditorHud () {
    // this.scene.stop('EditorHudScene')
    this.scene.wake('HudScene')
  }

  hideEditorHud () {
    this.scene.sleep('EditorHudScene')
    this.scene.wake('NonEditorHudScene')
  }

  unhideEditorHud () {
    // this.scene.wake('EditorHudScene')
  }

  update (time, delta) {
    this.cameraController.update(time, delta)
    // this.spawner.update(time, delta)

    // if the framerate is not doing well, adjust moving obstacle speeds
    this.tweens.timeScale = 16.66 / delta

    if (this.restartTimer > 0) {
      this.restartTimer -= delta / 1000
      if (this.restartTimer <= 0) {
        this.restart()
      }
    }

    if (this.keyTestWasDown && !this.keyTest.isDown) {
      this.sleeptime += 0.01
    }
    this.keyTestWasDown = this.keyTest.isDown

    if (this.sleeptime > 0 && location.hostname === 'localhost') {
      this.sleep(this.sleeptime)
    }
  }

  gameover (hideTitle = true, restartTimer = 1) {
    this.difficultyManager.onLevelFailed(100)

    this.scene.stop('SkipLevelScene')
    this.player.isGameOver = true
    this.restartTimer = restartTimer
    this.game.registry.set('hideTitle', hideTitle)
    // if (this.isCustomLevel || this.isLevelURL) {
    this.game.registry.set('lastLevel', this.levelEditor.save())
    // } else {
    // this.game.registry.set('lastLevel', this.levelId)
    // }
    this.game.registry.inc('respawn')
    if (!hideTitle) {
      if (this.isLevelURL) {
        // this.game.registry.set('ignoreURL', true)
      }
    }
    PokiWrapper.gameplayStop()
    AnalyticsWrapper.addProgressionEvent(ANALYTICS_FAIL, 'level_' + this.levelIdString())

    if (restartTimer <= 0) {
      this.restart()
    }
  }

  skipLevel () {
    this.scene.stop('SkipLevelScene')
    PokiWrapper.gameplayStop()
    this.player.pause()
    PokiWrapper.rewardedBreak(
      (success) => {
        this.player.unpause()
        if (success) {
          this.difficultyManager.increaseRating(-300)
          this.player.teleportToFinish()
        } else {
          this.player.unpause()
        }
      }
    )
  }

  finish () {
    if (!this.finished) {
      // console.log('finished with ' + this.game.registry.get('respawn') + ' respawns')
      this.difficultyManager.onLevelSuccess(this.game.registry.get('respawn') || 0)

      this.scene.stop('SkipLevelScene')
      this.finished = true
      this.restartTimer = 4
      if (!this.isCustomLevel) {
        AnalyticsWrapper.addProgressionEvent(ANALYTICS_COMPLETE, 'level_' + this.levelIdString())
        var unlockedAnimal = TitleScene.hasJustUnlocked(this.levelId)
        if (unlockedAnimal > 0) {
          this.restartTimer = 4.5
          this.game.registry.set('selectedAnimal', unlockedAnimal)
        }
        this.levelId++
        this.game.registry.set('nTries', 0)
        this.saveLevelProgress(this.levelId)
        this.game.registry.set('hideTitle', false)
        this.game.registry.set('respawn', 0)
      } else if (this.isLevelURL) {
        // this.game.registry.set('ignoreURL', true)
      } else {
        this.game.registry.set('hideTitle', true)
        this.game.registry.inc('respawn')
        this.game.registry.set('lastLevel', this.levelEditor.save())
      }

      PokiWrapper.gameplayStop()
      // if (PokiWrapper.isActive()) {
      // this.getBanner().displayAd()
      // }
    }
  }

  restart (setY = true) {
    this.scene.stop('HudScene')
    this.scene.stop('NonEditorHudScene')
    // this.scene.stop('EditorHudScene')
    this.scene.stop('SkipLevelScene')
    this.scene.restart('GameScene')
    if (setY) { this.game.registry.set('lastPlayerY', this.player.image.y) }
  }

  saveLevelProgress (levelId) {
    try { window.localStorage.setItem('levelId', this.levelId) } catch (e) { this.game.registry.set('levelIdBackup', levelId) }
    // this.difficultyManager.saveRating()
  }

  loadLevelProgress () {
    try {
      return parseInt(window.localStorage.getItem('levelId')) || 1
    } catch (e) { return this.game.registry.get('levelIdBackup') || 1 }
  }

  levelIdString () {
    if (this.levelId < 10) {
      return '0' + this.levelId
    }
    return this.levelId
  }

  CMYKtoRGB (C, M, Y, K) {
    const r = 255 * (1 - C) * (1 - K)
    const g = 255 * (1 - M) * (1 - K)
    const b = 255 * (1 - Y) * (1 - K)
    return { r, g, b }
  }

  genColorsNew () {
    const colorSchemes = []
    colorSchemes.push({ // #248
      bg: { c: 0.35, m: 0.10, y: 0.14, k: 0 },
      fg: { c: 0.15, m: 0.38, y: 0.55, k: 0 },
      sp: { c: 0.13, m: 0.73, y: 1.00, k: 0 },
      mv: { c: 0.85, m: 0.79, y: 0.38, k: 0.16 }
    })
    colorSchemes.push({ // #211
      bg: { c: 0.25, m: 0, y: 0.1, k: 0 },
      fg: { c: 0.20, m: 0.25, y: 0.4, k: 0.06 },
      sp: { c: 0, m: 0.28, y: 0.68, k: 0 },
      mv: { c: 1, m: 0.4, y: 0.3, k: 0.1 }
    })
    colorSchemes.push({ // #229
      bg: { c: 0.35, m: 0.10, y: 0.14, k: 0 },
      fg: { c: 0.53, m: 0.28, y: 1.0, k: 0.08 },
      sp: { c: 0.04, m: 0.04, y: 0.28, k: 0 },
      mv: { c: 0.0, m: 0.55, y: 0.40, k: 0.0 }
    })

    colorSchemes.push({
      bg: 'ffb3f0',
      fg: '6f0043',
      sp: '9b5348',
      mv: 'b5d1cc'
    })
    colorSchemes.push({
      bg: 'cc1a97',
      fg: 'f59994',
      sp: '6ea900',
      mv: '008aa1'
    })
    colorSchemes.push({
      fg: '34774b',
      sp: 'aa8a13',
      mv: '75a09f',
      bg: '3810a0'
    })
    colorSchemes.push({
      fg: '065a1e',
      sp: 'ad7937',
      mv: '2a1918',
      bg: '9375bf'
    })
    colorSchemes.push({
      bg: '51829a',
      fg: '6e7339',
      sp: '93fcce',
      mv: 'c1e6ed'
    })
    colorSchemes.push({
      bg: '6169a1',
      fg: '5a1546',
      sp: '70d0cf',
      mv: '6598c2'
    })

    colorSchemes.push({
      bg: '54666a',
      fg: '14142e',
      sp: '84c3e2',
      mv: 'b29a9e'
    })
    colorSchemes.push({
      bg: '09CBB9',
      fg: '192838',
      sp: '85804F',
      mv: '09CBB9'
    })

    colorSchemes.push({
      bg: 'CEBB75',
      fg: '643C39',
      sp: 'FAF2C0',
      mv: '66361A'
    })

    colorSchemes.push({
      bg: 'A8A272',
      fg: '3F3A35',
      sp: 'C6CDCD',
      mv: '58696A'
    })

    colorSchemes.push({
      bg: '712f7b',
      fg: '486f38',
      sp: 'e6e8ec',
      mv: '67c23f'
    })

    // colorSchemes.push({ // #228 is niet zo mooi
    //   bg: { c: 0.18, m: 0.58, y: 1.0, k: 0.12 },
    //   sp: { c: 0.0, m: 0.45, y: 1.0, k: 0 },
    //   fg: { c: 0.76, m: 0.32, y: 0.91, k: 0.18 },
    //   mv: { c: 0.0, m: 0.45, y: 1.00, k: 0.0 }
    // })

    // 176
    // #0d75ff blu
    // #00d973 bnz
    // #ffb852 y
    // #ff8c00 or
    // colorSchemes.push({
    //   bg: '0024CC',
    //   fg: '0D2B52',
    //   sp: 'ffb852',
    //   mv: 'ff8c00'
    // })

    const scheme = colorSchemes[colorSchemes.length - 1]
    // const scheme = Phaser.Math.RND.pick(colorSchemes)
    if (scheme.bg.c) {
      const fg = this.toColorStringNew(this.CMYKtoRGB(scheme.fg.c, scheme.fg.m, scheme.fg.y, scheme.fg.k))
      const sp = this.toColorStringNew(this.CMYKtoRGB(scheme.sp.c, scheme.sp.m, scheme.sp.y, scheme.sp.k))
      const mv = this.toColorStringNew(this.CMYKtoRGB(scheme.mv.c, scheme.mv.m, scheme.mv.y, scheme.mv.k))
      const bgRGB = this.CMYKtoRGB(scheme.bg.c, scheme.bg.m, scheme.bg.y, scheme.bg.k)
      const bg = this.toColorStringNew(bgRGB)
      var r2 = Phaser.Math.Linear(bgRGB.r, 0, 0)
      var g2 = Phaser.Math.Linear(bgRGB.g, 0, 0)
      var b2 = Phaser.Math.Linear(bgRGB.b, 0, 0)
      const bg2 = this.toColorString(r2) + this.toColorString(g2) + this.toColorString(b2)
      var r3 = Phaser.Math.Linear(bgRGB.r, 255, 0.5)
      var g3 = Phaser.Math.Linear(bgRGB.g, 255, 0.5)
      var b3 = Phaser.Math.Linear(bgRGB.b, 255, 0.5)
      const gu = this.toColorString(r3) + this.toColorString(g3) + this.toColorString(b3)
      return { bg, bg2, fg, sp, mv, gu }
    } else {
      const bgRGB = this.stringToRGB(scheme.bg)
      var r2 = Phaser.Math.Linear(bgRGB.r, 255, 0.65)
      var g2 = Phaser.Math.Linear(bgRGB.g, 255, 0.65)
      var b2 = Phaser.Math.Linear(bgRGB.b, 255, 0.65)
      const bg2 = this.toColorString(r2) + this.toColorString(g2) + this.toColorString(b2)
      var r3 = Phaser.Math.Linear(bgRGB.r, 255, 0.5)
      var g3 = Phaser.Math.Linear(bgRGB.g, 255, 0.5)
      var b3 = Phaser.Math.Linear(bgRGB.b, 255, 0.5)
      const gu = this.toColorString(r3) + this.toColorString(g3) + this.toColorString(b3)

      return { bg: scheme.bg, bg2: bg2, fg: scheme.fg, sp: scheme.sp, mv: scheme.mv, gu: gu }
    }
  }

  stringToRGB (string) {
    const r = parseInt('0x' + string.substring(0, 2))
    const g = parseInt('0x' + string.substring(2, 4))
    const b = parseInt('0x' + string.substring(4, 6))
    return { r, g, b }
  }

  toColorStringNew (color) {
    return this.toColorString(color.r) + this.toColorString(color.g) + this.toColorString(color.b)
  }

  genColors (len) {
    // Randomly generate background color, making sure it is not too dark, but also not too bright:
    var r = 100 + Math.random() * 120
    var g = 100 + Math.random() * 120
    var b = 100 + Math.random() * 120

    /*
    // desaturate
    if (r > b && r > g) {
      b = Phaser.Math.Linear(b, r, 0.75)
      g = Phaser.Math.Linear(g, r, 0.75)
    } else if (g > r && g > b) {
      r = Phaser.Math.Linear(r, g, 0.75)
      b = Phaser.Math.Linear(b, g, 0.75)
    } else if (b > r && b > g) {
      r = Phaser.Math.Linear(r, b, 0.75)
      g = Phaser.Math.Linear(g, b, 0.75)
    } */

    // make the colors brighter at the top
    var r1 = Phaser.Math.Linear(r, 255, 0.75)
    var g1 = Phaser.Math.Linear(g, 255, 0.75)
    var b1 = Phaser.Math.Linear(b, 255, 0.75)

    // var bg = this.toColorString(r1) + this.toColorString(g1) + this.toColorString(b1)
    var bg = this.toColorString(r) + this.toColorString(g) + this.toColorString(b)

    // Calculate gradient color and foreground color:
    var bg2 = this.toColorString(r) + this.toColorString(g) + this.toColorString(b)
    var fg = this.toColorString(r * 0.5) + this.toColorString(g * 0.5) + this.toColorString(b * 0.5)

    var r3 = Phaser.Math.Linear(r, 255, 0.5)
    var g3 = Phaser.Math.Linear(g, 255, 0.5)
    var b3 = Phaser.Math.Linear(b, 255, 0.5)
    const gu = this.toColorString(r3) + this.toColorString(g3) + this.toColorString(b3)

    // Spikes are colored "opposite" to the background:
    if (r > g && r > b) {
      // console.log('Mostly red, make spikes yellow-green')
      r = 100 + Math.random() * 156
      g = 200 + Math.random() * 56
      b = 0 + Math.random() * 56
    } else if (b > r && b > g) {
      // console.log('Mostly blue, make spikes green or red')
      r = 0 + Math.random() * 256
      g = (256 - r) + Math.random() * r
      b = 0 + Math.random() * 100
    } else if (g > r && g > b) {
      // console.log('Mostly green, make spikes white-blue')
      r = 128 + Math.random() * 128
      g = 128 + Math.random() * 128
      b = Math.max(r, g) + Math.random() * (256 - Math.max(r, g))
    }
    /*
    // desaturate
    if (r > b && r > g) {
      b = Phaser.Math.Linear(b, r, 0.5)
      g = Phaser.Math.Linear(g, r, 0.5)
    } else if (g > r && g > b) {
      r = Phaser.Math.Linear(r, g, 0.5)
      b = Phaser.Math.Linear(b, g, 0.5)
    } else if (b > r && b > g) {
      r = Phaser.Math.Linear(r, b, 0.5)
      g = Phaser.Math.Linear(g, b, 0.5)
    } */

    var sp = this.toColorString(r) + this.toColorString(g) + this.toColorString(b)

    const mv = '0000FF'
    // const gu = 'ffffff'

    return { bg, bg2, fg, sp, mv, gu }
  }

  toColorString (color) {
    var a = Math.floor(color / 16)
    var b = Math.floor(color % 16)
    var str = ''
    str += a.toString(16)
    str += b.toString(16)
    return str
  }
}
